import en from './en-us.json'
import pt from './pt-br.json'

const locales: { [key: string]: any } = {
  'en': en,
  'en-us': en,
  'pt': pt,
  'pt-br': pt
}

const browserLang = navigator.language.toLowerCase()
const dictionary = locales[browserLang] || en

export function t(key: string): string {
  return dictionary[key] || key
}
